import { REIMBURSEMENTS_FILTER_SESSION_KEY } from '../constants'
import type { ReimbursementFilters } from '../types'

const SESSION_SOURCE_KEY = '__source'
const SESSION_SOURCE_VALUE = 'reimbursements_react_v2'

const ALLOWED_FILTER_KEYS: Array<keyof ReimbursementFilters> = [
  'page',
  'perPage',
  'orderBy',
  'sortBy',
  'q',
  'org_id',
  'companyId',
  'propertyId',
  'org_name',
  'company_name',
  'property_name',
  'reimbursement_type',
  'rentalStatus',
  'defaultStatus',
  'claim_status',
  'document_status',
  'review_decision',
  'past_customer',
  'notification_fromDt',
  'notification_toDt',
  'lease_start_fromDt',
  'lease_start_toDt',
  'claim_status_fromDt',
  'claim_status_toDt',
]

export function saveReimbursementFiltersToSession(filters: ReimbursementFilters): void {
  try {
    sessionStorage.setItem(
      REIMBURSEMENTS_FILTER_SESSION_KEY,
      JSON.stringify({
        ...filters,
        [SESSION_SOURCE_KEY]: SESSION_SOURCE_VALUE,
      }),
    )
  } catch (e) {
    console.error('Failed to save reimbursements filters to session:', e)
  }
}

export function readReimbursementFiltersFromSession(): Partial<ReimbursementFilters> | null {
  try {
    const raw = sessionStorage.getItem(REIMBURSEMENTS_FILTER_SESSION_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Record<string, unknown>
    if (parsed[SESSION_SOURCE_KEY] !== SESSION_SOURCE_VALUE) return null
    const cleaned: Partial<ReimbursementFilters> = {}
    for (const key of ALLOWED_FILTER_KEYS) {
      if (Object.prototype.hasOwnProperty.call(parsed, key)) {
        cleaned[key] = parsed[key] as never
      }
    }
    return cleaned
  } catch (e) {
    console.error('Failed to read reimbursements filters from session:', e)
    return null
  }
}

export function clearReimbursementFiltersFromSession(): void {
  try {
    sessionStorage.removeItem(REIMBURSEMENTS_FILTER_SESSION_KEY)
  } catch (e) {
    console.error('Failed to clear reimbursements filters from session:', e)
  }
}
